{
  "page_title": "MCP connection",
  "requests_access": "Allow {clientName} to access %APP_NAME%?",
  "requests_access_description": "The application will be able to work with your organization’s data within your access permissions.",
  "scope_mcp_read": "View employee, time-off, and goal data available to you",
  "scope_mcp_write": "Create and update data available to you",
  "scope_unknown": "Additional permission: {scope}",
  "scopes_hint": "The application gets an unchecked permission only after you reconnect it.",
  "allow": "Allow",
  "deny": "Don’t allow",
  "loading": "Loading…",
  "error_title": "Authorization error",
  "generic_error": "Something went wrong. Please try again.",
  "error_invalid_scope": "The application requested permissions that are not available to it.",
  "error_invalid_client": "Unknown or disabled application. Reconnect it and try again.",
  "error_invalid_request": "The authorization request is malformed (redirect address or parameters). Restart the connection from the application."
}
